export const basic = {
  sku: 'bm-pn',
  price: 19.99,
};

export const plus = {
  sku: 'vm-pn',
  price: 29.99,
};
